module.exports = __webpack_public_path__ + "static/img/images-register-done@3x.5d277958.png";